import { render, staticRenderFns } from "./GameControlBtn.vue?vue&type=template&id=251ca085&scoped=true&"
import script from "./GameControlBtn.vue?vue&type=script&lang=js&"
export * from "./GameControlBtn.vue?vue&type=script&lang=js&"
import style0 from "./GameControlBtn.vue?vue&type=style&index=0&id=251ca085&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251ca085",
  null
  
)

export default component.exports